<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useLearningAuthStore } from '@stores/auth'
import Modal from '@components/modal/Modal.vue'
const router = useRouter()
const { resetAuth } = useLearningAuthStore()

const showLogoutModal = ref(false)
const showWithdrawModal = ref(false)

const navItems = [
  // {
  //   id: 'account',
  //   name: '登録情報',
  //   type: 'app',
  //   action () {
  //     router.push({ name: 'Account' })
  //   }
  // },
  // {
  //   id: 'passwordEdit',
  //   name: 'パスワード変更',
  //   type: 'app',
  //   action () {
  //     router.push({ name: 'PasswordEdit' })
  //   }
  // },
  // {
  //   id: 'MailTop',
  //   name: 'メールアドレス変更',
  //   type: 'app',
  //   action () {
  //     router.push({ name: 'MailTop' })
  //   }
  // },
  {
    id: 'logout',
    name: 'ログアウト',
    type: 'app',
    async action () {
      showLogoutModal.value = true
    }
  },
  // {
  //   id: 'withdraw',
  //   name: '退会',
  //   type: 'app',
  //   async action () {
  //     showWithdrawModal.value = true
  //   }
  // }
]

const logout = async () => {
  // ログアウトAPIはないのでtokenの削除のみ
  resetAuth()
  router.push({ name: 'Login' })
}

const withdraw = async () => {
  // todo退会処理
}
</script>

<template>
  <section class="l-page">
    <div class="l-page__wrapper">
      <ul class="p-menu">
        <li
          v-for="item in navItems"
          :key="item.id"
        >
          <button
            type="button"
            class="p-menu__item"
            @click="item.action"
          >
            <div
              class="p-menu__label"
            >
              {{ item.name }}
            </div>
            <i :class="`p-menu__${item.type}`" />
          </button>
        </li>
      </ul>
    </div>

    <Modal :show="showLogoutModal">
      <template #body>
        <div class="l-modal__body">
          <h2 class="l-modal__ttl">
            ログアウトします、よろしいですか？
          </h2>
          <div class="l-modal__buttons l-modal__buttons--twin">
            <button
              class="c-modalBtn c-modalBtn--twin c-modalBtn--black"
              type="button"
              @click="showLogoutModal = false"
            >
              いいえ
            </button>
            <button
              class="c-modalBtn c-modalBtn--twin c-modalBtn--gray"
              type="button"
              @click="logout"
            >
              はい
            </button>
          </div>
        </div>
      </template>
    </Modal>

    <Modal :show="showWithdrawModal">
      <template #body>
        <div class="l-modal__body">
          <h2 class="l-modal__ttl">
            退会します、よろしいですか？
          </h2>
          <div class="l-modal__buttons l-modal__buttons--twin">
            <button
              class="c-modalBtn c-modalBtn--twin c-modalBtn--black"
              type="button"
              @click="showWithdrawModal = false"
            >
              いいえ
            </button>
            <button
              class="c-modalBtn c-modalBtn--twin c-modalBtn--gray"
              type="button"
              @click="withdraw"
            >
              はい
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<style scoped lang="scss">
</style>
